import { useEffect } from 'react';
import { socketService } from '@/services/socket';

/**
 * Subscribe to a single socket.io event for the lifetime of the
 * consuming component.
 *
 * Caller asserts the payload type. Use `useCallback` if the handler
 * captures changing state — socketService.off needs the same reference.
 */
export function useSocketEvent<T = unknown>(
  event: string,
  handler: (payload: T) => void,
  enabled = true,
): void {
  useEffect(() => {
    if (!enabled) return;
    const wrapper = (data: unknown) => handler(data as T);
    socketService.on(event, wrapper);
    return () => socketService.off(event, wrapper);
  }, [event, handler, enabled]);
}
